module.exports = __webpack_public_path__ + "img/banner_bg_img.469c0a64.png";